"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_ROUTES = void 0;
exports.API_ROUTES = {
    getNonceURL: (account, query) => `/v4/user/auth/getNonce/${account}${query}`,
    getJwtUrl: () => "/v4/user/auth",
    getTokenUrl: (string) => `/v4/tokens/${string}`,
    getTokenHistoryUrl: (string, query) => `/v4/tokens/${string}/history${query}`,
    createTokenUrl: () => "/v4/tokens",
    getTokensUrl: (query) => `/v4/tokens${query}`,
    getUserStatsByAccountUrl: (account) => `/v4/users/${account}/stats`,
    getUserByAccountUrl: (account) => `/v4/users/${account}`,
    getUsersUrl: (query) => `/v4/users${query}`,
    updateUserUrl: (account) => `/v4/users/${account}`,
    getUserRefStatsUrl: (account) => `/v4/users/${account}/stats`,
    requestCreatorUrl: (account) => `/v4/creators/${account}`,
    rejectCreatorUrl: (account) => `/v4/creators/${account}`,
    getCreatorsUrl: (query) => `/v4/creators${query}`,
    getCollections: (query) => `/v4/collections${query}`,
    getCollectionById: (id) => `/v4/collections/${id}`,
    getCollectionStats: (id) => `/v4/collections/${id}/stats`,
    getCollectionNames: () => `/v4/collections/names`,
    createCollection: () => `/v4/collections/`,
    updateCollection: (id) => `/v4/collections/${id}`,
    getUserRating: (query) => `/v4/user/rating${query}`,
    getCollectionRating: (query) => `/v4/collection/rating${query}`,
    getRefRating: (query) => `/v4/user/ref/rating${query}`,
    requestLotteryWinnerVoucher: () => `/v4/voucher/winner`,
    requestLotteryTicketsVoucher: () => `/v4/voucher/tickets`,
    requestAuctionBidVoucher: () => `/v4/voucher/bid`,
    requestAuctionBuyNowVoucher: () => `/v4/voucher/buyNow`,
    requestAuctionFinalizeVoucher: () => `/v4/voucher/finalizeAuction`,
    requestMarketBuyVoucher: () => `/v4/voucher/buy`,
    requestMarketBulkBuyVoucher: () => `/v4/voucher/bulkBuy`,
    postTokenById: (id) => `/v4/admin/tokenmetadata/${id}`,
    updateCollectionByAdmin: (id) => `/v4/admin/collections/${id}`,
    updateUserByWallet: (wallet) => `/v4/admin/user/${wallet}`,
};
